import _ from 'lodash';

export const SAGA_GET_EVENTS = 'SAGA_GET_EVENTS';
export const SET_EVENTS = 'SET_EVENTS';
export const RESET_EVENTS = 'RESET_EVENTS';
export const SET_BOUNDS_EVENTS = 'SET_BOUNDS_EVENTS';

export const setEvents = (lore, lee) => {
    return {
        type: SET_EVENTS,
        payload: {
            lore,
            lee,
        },
    }
}

export const resetEvents = () => {
    return {
        type: RESET_EVENTS,
        payload: {},
    }
}

export const setBoundsEvents = (bounds) => {
    return {
        type: SET_BOUNDS_EVENTS,
        payload: {
            bounds,
        }
    }
}


// WEBPACK FOOTER //
// ./src/Events/actions.js